/* eslint-disable no-console */
/* eslint-disable radix */
/* eslint-disable  react/no-danger */
/* eslint-disable max-len */

import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import '../../styles/header.scss';
import { modifiedDate } from '../../shared/constantVariable';

const Footer = () => {
  // const navigate = useNavigate();
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const location = window.location.pathname;
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  useEffect(() => {
    setCurrentPath(location.pathname);
  }, [location]);
  // const restrictPaths = ['/sign-in', '/home', '/forgot-password', '/sign-up', '/reset_pwd', '/recent-files-list',
  const restrictPaths = ['/home', '/forgot-password', '/sign-up', '/reset_pwd', '/recent-files-list',
    '/preconfig', '/my-projects', '/shared-projects', '/maintaince'];

  const getFooter = () => {
    if (restrictPaths.includes(currentPath)) return null;
    return (
      <div className="footer">
        <p className="version-name">
          {(() => {
            // change the date only one palce and update every where in this application
            // variable name is `modifiedDate` Path : src\shared\constantVariable.js
            // Added by chandrashekhar
            const data = modifiedDate.split('-');
            const x = 0; const y = data.length - 1;
            data[x] = data.splice(y, 1, data[x])[0];
            return (`Version - 5.0 ${data.join('/')}`);
          })()}
          {/* Version - 5.0 17/04/2025 */}
        </p>
        <div className="large-12 columns footer-bottom">
          <nav role="navigation" aria-labelledby="block-ge-water-footer-menu" id="block-ge-water-footer" className="block-ge-water-footer">
            <ul className="menu">
              <li className='S_Regular'>2025 © Copyright Veolia</li>
              <li className='S_Regular'>
                <a href="https://www.watertechnologies.com/privacy-policy-notice" target="_blank" rel="noreferrer">Privacy</a>
              </li>
              <li className='S_Regular'>
                <a href="https://eStore.watertechnologies.com/accessibility" target="_blank" rel="noreferrer">Accessibility</a>
              </li>
              <li className='S_Regular'>
                <a href="https://www.veolia.com/en/veolia-group/governance/ethics-committee" target="_blank" rel="noreferrer">Veolia Ethics Committee</a>
              </li>
              <li className='S_Regular'>
                <a href="https://www.watertechnologies.com/terms" target="_blank" rel="noreferrer">Terms &amp; Conditions</a>
              </li>
              <li className='S_Regular'>
                <a href="https://www.watertechnologies.com/vwts-cookie-notice" target="_blank" rel="noreferrer">Cookie Notice</a>
              </li>
            </ul>
          </nav>
          <section id="block-trademark" className="block-trademark Xs_Regular" style={{ textAlign: 'center' }}>
            <small><i>*Trademark of Veolia; may be registered in one or more countries.</i></small>
          </section>
        </div>
      </div>
    );
  };

  return (
    <div>
      {getFooter()}
    </div>
  );
};

export default Footer;
